export default __webpack_public_path__ + "static/background-1-bcc20f1a0b56e9f6980890528ae75ad7.svg";